export default __webpack_public_path__ + "static/media/asigna-gr.8f475cb3.svg";